export enum InterviewsStatus {
  Scheduled = 'Scheduled',

  Completed = 'Completed',
}
